import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getPopularComics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function FeaturedSection() {
  const { t } = useTranslation();
  const popularComics = getPopularComics(8);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              {t('section.featured')}
            </h2>
            <p className="text-sm text-foreground-500 mt-2">最受读者欢迎的韩漫精选</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-6" data-product-shop>
          {popularComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}